<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxButton, DxColumn } from 'devextreme-vue/data-grid';

    export default {
        components: {
            AdminGrid,
            DxButton,
            DxColumn
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('sms-subscriptions/grid')
            };
        },
        methods: {
            openLookup(row) {
                this.$router.push({ path: '/sms-lookup', query: { phone: row.data.phoneNumber } });
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-chat-dots"></i>
            SMS Subscriptions
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="sms-subscriptions" :show-actions="false">
            <DxColumn type="buttons" caption="" :width="60">
                <DxButton icon="search" hint="See this number's messages" :on-click="openLookup" />
            </DxColumn>
            <DxColumn data-field="userName" caption="User" />
            <DxColumn data-field="companyName" caption="Company" />
            <DxColumn data-field="phoneNumber" caption="Phone" />
            <DxColumn data-field="subscriptionStatus" caption="SMS status" sort-order="desc" />
            <DxColumn data-field="unsubscribedAt" caption="Unsubscribed" data-type="date" format="MM/dd/yyyy hh:mm a" />
        </AdminGrid>
    </div>
</template>
